<template>
  <div class="main_div" :style="backgroundGradient">
    <div class="absolute top-0 right-0 p-5">
      <header-actions
        :show-popout-button="showPopoutButton"
        :icon-class="textColorClass"
      />
    </div>

    <div class="main_div_head">
      <img v-if="!isAvatarValid" src="../../assets/image/main.svg" alt="icon" />
      <img
        v-if="isAvatarValid"
        class="h-8 w-8 rounded-full mr-3"
        :src="avatarUrl"
        alt="avatar"
      />
      <span v-if="isAvatarValid" :class="textColorClass">{{ title }}</span>
      <!-- <div
        :class="`h-2 w-2 ml-1 rounded-full
        ${isOnline ? 'bg-green-500' : 'hidden'}`"
      /> -->
    </div>

    <div v-if="!collapsed" class="main_div_body">
      <h3 :class="textColorClass" class="welcome_text">
        {{ introHeading || 'Hello There👋🏻' }}
      </h3>
      <p :class="textColorClass" class="welcome_text_p">
        {{
          introBody ||
          'We are here to help you with your questions. Ask anything, or share your feedback.'
        }}
      </p>
    </div>
    <!-- 
    <div class="main_body_avatar">
      <img
        v-for="(agent, index) in availableAgents"
        :key="index"
        :src="agent.avatar_url"
        alt="agent image"
        class="profile"
      />
    </div> -->
    <!-- <div class="px-4 pt-4 w-full">
      <team-availability
        :available-agents="availableAgents"
        :has-conversation="!!conversationSize"
        :unread-count="unreadMessageCount"
        @start-conversation="startConversation"
      />
    </div> -->
  </div>
</template>

<script>
import { getLuminance, lighten } from 'color2k';
import { mapGetters } from 'vuex';
import availabilityMixin from 'widget/mixins/availability';
import nextAvailabilityTime from 'widget/mixins/nextAvailabilityTime';
import routerMixin from 'widget/mixins/routerMixin';
import darkMixin from 'widget/mixins/darkModeMixin.js';
import { hasValidAvatarUrl } from '../../../../dashboard/helper/URLHelper';
import HeaderActions from 'widget/components/HeaderActions.vue';

export default {
  name: 'TopBar',
  components: {
    HeaderActions,
  },
  mixins: [nextAvailabilityTime, availabilityMixin, routerMixin, darkMixin],
  props: {
    avatarUrl: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    introBody: {
      type: String,
      default: '',
    },
    introHeading: {
      type: String,
      default: '',
    },
    showPopoutButton: {
      type: Boolean,
      default: false,
    },
    showBackButton: {
      type: Boolean,
      default: false,
    },
    availableAgents: {
      type: Array,
      default: () => {},
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
      isWidgetOpen: 'appConfig/getIsWidgetOpen',
      activeCampaign: 'campaign/getActiveCampaign',
      conversationSize: 'conversation/getConversationSize',
      unreadMessageCount: 'conversation/getUnreadMessageCount',
      popularArticles: 'article/popularArticles',
      articleUiFlags: 'article/uiFlags',
    }),
    backgroundGradient() {
      return {
        background: this.generateGradient(this.widgetColor),
      };
    },
    isOnline() {
      const { workingHoursEnabled } = this.channelConfig;
      const anyAgentOnline = this.availableAgents.length > 0;

      if (workingHoursEnabled) {
        return this.isInBetweenTheWorkingHours;
      }

      return anyAgentOnline;
    },

    isAvatarValid() {
      return hasValidAvatarUrl(this.avatarUrl);
    },
    textColorClass() {
      return this.isDarkBackground(this.widgetColor)
        ? 'light-text'
        : 'dark-text';
    },
  },

  methods: {
    generateGradient(color) {
      const secondaryColor = lighten(color, 0.2); // Lighten the base color by 20%
      const gradient = `linear-gradient(315.76deg, ${secondaryColor} -0.84%, ${color} 66.5%)`;
      return gradient;
    },
    isDarkBackground(color) {
      // Calculate luminance
      const luminanceValue = getLuminance(color);
      // Return true if background is dark, false if it is light
      return luminanceValue < 0.5;
    },
  },
};
</script>

<style scoped>
.light-text {
  color: white;
}
.dark-text {
  color: black;
}
</style>
